(function(algolia) {
  'use strict';

  if (!algolia.config.autocomplete_enabled) return;

  /**
   * 
   * Mobile search results nav tabs
   */
  function qdDebounce(func, delay) {
    let timerId;
  
    return function (...args) {
      clearTimeout(timerId);
  
      timerId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }
  function panelMobileTabs () {
    let controlItems = document.querySelectorAll('.aa-PanelSections__nav-item');
        if(controlItems) {
          controlItems.forEach(function(item) {
            item.addEventListener('click', function(e) {
              e.preventDefault();
              document.querySelectorAll('.aa-PanelSections__nav-item.active').forEach(function(item) {
                item.classList.remove('active');
              });
      
              let controls = e.target.getAttribute('aria-controls');
              let controledItem = document.getElementById(`${controls}`);
              if(controledItem) {
                document.querySelectorAll('.aa-PanelSections__tab-content').forEach(function(item) {
                  item.style.display = 'none'
                });
                e.target.classList.add('active');
                controledItem.style.display = 'block';
              }
            });
          })
        }
  }
  const debouncedPanelMobileTabs= qdDebounce(panelMobileTabs, 500);
  const debouncedtoggleMobileView = qdDebounce(toggleMobileView, 500);

  function toggleMobileView() {
    document
      .querySelector('.aa-PanelSections__tab-content-stats .ais-change-display-block')
      .addEventListener('click', function() {
        document
          .querySelector(
            '.aa-PanelSections__tab-content-stats .ais-change-display-block:not(.ais-change-display-selected)'
          )
          ?.classList.add('ais-change-display-selected');
        document
          .querySelector(
            '.aa-PanelSections__tab-content-stats .ais-change-display-list.ais-change-display-selected'
          )
          ?.classList.remove('ais-change-display-selected');
        document
          .querySelector('#aa-PanelSections__tab-products .aa-List')
          ?.classList.remove('aa-List--block');
      });
    document
      .querySelector('.aa-PanelSections__tab-content-stats .ais-change-display-list')
      .addEventListener('click', function() {
        document
          .querySelector(
            '.aa-PanelSections__tab-content-stats .ais-change-display-list:not(.ais-change-display-selected)'
          )
          ?.classList.add('ais-change-display-selected');
        document
          .querySelector(
            '.aa-PanelSections__tab-content-stats .ais-change-display-block.ais-change-display-selected'
          )
          ?.classList.remove('ais-change-display-selected');
        document
          .querySelector('#aa-PanelSections__tab-products .aa-List')
          ?.classList.add('aa-List--block');
      });
  }

  const autocomplete = algolia.externals.autocomplete;

  algolia.searchClient.addAlgoliaAgent('Shopify Integration');

  // Retrieve the container from Shopify's config
  const containers = Array.from(document.querySelectorAll(algolia.config.input_selector));
  containers.forEach(container => {
    container.innerHTML = ''
    const containerClasses = container.classList;
    containerClasses.add('aa-MainContainer');
  });

  // Set plugins
  const { productsPlugin, collectionsPlugin, articlesPlugin, pagesPlugin, querySuggestionsPlugin } = algolia;
  const plugins = [
    algolia.config.index_products && productsPlugin,
    algolia.config.index_collections && collectionsPlugin,
    algolia.config.index_articles && articlesPlugin,
    algolia.config.index_pages && pagesPlugin,
    algolia.config.autocomplete_query_suggestions && querySuggestionsPlugin
  ];

  const cssFile = document.getElementById('template_algolia_autocomplete.css');
  //Set CSS variables
  document.documentElement.style.setProperty(`--aa-text-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.secondary)}`);
  document.documentElement.style.setProperty(`--aa-primary-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.main)}`);
  document.documentElement.style.setProperty(`--aa-muted-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.muted)}`);
  document.documentElement.style.setProperty(`--aa-highlight-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
  //Link CSS
  algolia.appendStyle(cssFile.text);

  const autocompleteOptions = {
    openOnFocus: false,
    autoFocus: true,
    debug: algolia.config.autocomplete_debug,
    insights: algolia.config.analytics_enabled,
   // detachedMediaQuery: 'none',
    plugins,
    render({ elements, render, html, state }, root) {
      const sourceIdsToExclude = ['products'];
      const hasLeftPanelResults = state.collections
              .filter(
                      ({ source }) => sourceIdsToExclude.indexOf(source.sourceId) === -1
              )
              .reduce((prev, curr) => prev + curr.items.length, 0) > 0;
      const [querySuggestionsPluginResults] = state.collections.filter(({source}) => source.sourceId === 'querySuggestionsPlugin');
      const displaySuggestions = algolia.config.autocomplete_query_suggestions && querySuggestionsPluginResults.items.length > 0;
      render(
              hasLeftPanelResults ?
              algolia.mainTemplate({ html, state }, elements, displaySuggestions)
              : algolia.mainProductsTemplate({ html, state }, elements),
              root
      );
    },
    renderNoResults({ render, html, state }, root) {
      render(
              algolia.noResultsTemplate({ html, state }),
              root
      )
    },
    onSubmit({ state }) {
      window.location.href = `/search?q=${state.query}`;
    },
    onStateChange({ state }) {
      if(state.isOpen) {
        debouncedPanelMobileTabs();
        debouncedtoggleMobileView();
      }

    },
  }
  
  containers.forEach(container => {
    let ac = autocomplete({
      container,
      ...autocompleteOptions
    });
    document.querySelector('.search-modal__close-button').addEventListener('click', e => {
      ac.setQuery('');
    })
  });
})(window.algoliaShopify);
